import Locales from 'UdeskLocales';
import React, { forwardRef } from 'react';
import { RoleTag, TicketTextInfoContentHeader } from './components';
import { Space } from 'udesk-ui';
import XssComponent from 'udesk-react/src/components/xss';
import { replaceLineBreak, replaceLink } from 'src/util/text-replace';

interface TemplateProps {
    item?: any;
    content?: any;
    titleRef?: any;
}

const Template = forwardRef((props: TemplateProps, ref: any) => {
    const { item, titleRef, content } = props;

    const locales = Locales['current'];

    const { data = {} } = item;

    return (
        <>
            <TicketTextInfoContentHeader>
                <Space>
                    <div style={{ fontWeight: 600 }}>{data.sendUser}</div>
                    <RoleTag sender={data.sender}>
                        {data.sender === 1 || data.sender === '1'
                            ? /* 客户 */ locales.components.ticketTextInfo.index.customer
                            : /* 客服 */ locales.components.ticketTextInfo.index.customerService}
                    </RoleTag>
                </Space>
                {/* <div className='desc'>2021-12-28  19:57:02 回复至Dora Cardenas  收件人：doura.h.cardenas@gmail.com</div>     */}
                <div className="desc" ref={titleRef}>{`${data.createdTime}${
                    /* 回复至 */ locales.components.ticketTextInfo.index.replyTo
                }${data.recUser} `}</div>
                <div className="desc">{`${
                    /* 收件人: */ locales.components.ticketTextInfo.index.addressee
                }${data.recEmail}`}</div>
            </TicketTextInfoContentHeader>
            {/* <div ref={ref}>{content}</div> */}
            <div ref={ref}>
                <XssComponent value={replaceLineBreak(replaceLink(content))} />
            </div>
        </>
    );
});

export default Template;
